import { useTheme, useMediaQuery } from "@mui/material";
import ProfileUserDesktop from "../components/ProfileUserDesktop";
import ProfileUserMobile from "../components/ProfileUserMobile";

export default function ProfileUser() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return isMobile ? <ProfileUserMobile /> : <ProfileUserDesktop />;
}
